export default __webpack_public_path__ + "static/media/selvstaendige_header.547ec095.jpg";